const charDictEntries = Object.entries({
	" ": "␣",
	"\n": "↵",
	"\t": "→",
})
export function transformToVerboseString(value: string) {
	return charDictEntries.reduce((ret, [srcChar, dstChar]) => {
		return ret.replace(new RegExp(srcChar, 'g'), dstChar);
	}, value)
}
export function transformFromVerboseString(viewValue: string) {
	return charDictEntries.reduce((ret, [dstChar, srcChar]) => {
		return ret.replace(new RegExp(srcChar, 'g'), dstChar);
	}, viewValue)
}